<template>
  <div>
    <form ref="captchaContainer"></form>
  </div>
</template>

<script>
  export default {
    name: "Recaptcha",
    methods: {
      createCaptchaElement() {
        const captchaElement = document.createElement('div')
        captchaElement.className = 'g-recaptcha'
        captchaElement.setAttribute('data-sitekey', '6LflXH0UAAAAAI8IX7yJXjcEiqmskyphGqNO8Gln')
        captchaElement.setAttribute('data-callback', 'recaptchaCallback')
        captchaElement.setAttribute('data-theme', 'dark')
        captchaElement.setAttribute('id', 'recaptcha-element')
        return captchaElement
      },
      configureGRecaptcha() {
        const recaptcha = this.createCaptchaElement()
        this.$refs['captchaContainer'].appendChild(recaptcha)
        this.renderRecaptcha(recaptcha)
      },
      renderRecaptcha(recaptcha) {
        setTimeout(() => {
          try {
            grecaptcha.render(recaptcha)
          } catch(error) {
            return this.renderRecaptcha(recaptcha)
          }
        }, 20)
      },
      listenForRecaptcha() {
        gRecaptchaResponseEmitter.addEventListener('gRecaptchaResponse', event => {
          this.$emit('gRecaptchaResponse', event.detail)
        })
      }
    },
    mounted() {
      this.listenForRecaptcha()
      this.configureGRecaptcha()
    }
  }
</script>

<style>
  #recaptcha-element {
    margin-top: 5px;
    margin-bottom: 20px;
  }

  #recaptcha-element > div {
    margin: auto;
  }
</style>